import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { Radio } from '_components';
import { _ } from '_locales';

const Container = styled.div`
  font-size: 12px !important;
   
  float: left;
`;

const RemindOnChange = () => {
  const { register, setValue } = useFormContext();

  useEffect(() => {
    register({ name: 'remindOnChange' });
  }, []);

  const changeHandler = ({ target }) => {
    setValue('remindOnChange', target.value, { shouldValidate: true });
  };

  return (
    <Container>
      <div style={{
        display: 'inline-block',
        marginRight: '15px',
      }}
      >
        <Radio
          name="remindOnChange"
          value="everyTime"
          label={_('reminder.every_time')}
          onChange={changeHandler}
        />
      </div>
      <div style={{ display: 'inline-block' }}>
        <Radio
          name="remindOnChange"
          value="onlyHolidays"
          label={_('reminder.Only_when_there_are')}
          onChange={changeHandler}
        />
      </div>
    </Container>
  );
};

export default RemindOnChange;
